import * as React from "react";
import { Route, Switch } from "react-router-dom";

import {
	AdminPage,
	EntryPage,
	HomePage,
	LoginPage,
	MySectionsPage,
	ReportPage,
	ResetPasswordPage,
	SearchPage,
	SectionPage
} from "components/pages";
import { SearchHeader } from "components/general/SearchHeader";

export const routes = (
	<Switch>
		<Route exact={true} path="/" component={HomePage} />

		<Route path="/section" render={(props) => <SearchHeader component={SectionPage} {...props} />} />
		<Route path="/entry" render={(props) => <SearchHeader component={EntryPage} {...props} />} />
		<Route path="/my-sections" render={(props) => <SearchHeader component={MySectionsPage} {...props} />} />
		<Route path="/search" render={(props) => <SearchHeader component={SearchPage} {...props} />} />

		<Route path="/admin" component={AdminPage} />
		<Route path="/login" component={LoginPage} />
		<Route path="/reset-password/:token?" component={ResetPasswordPage} />
		<Route path="/report/:id" component={ReportPage} />
		<Route path="*" component={HomePage} />
	</Switch>
);
